














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class FormInputRow extends Vue {
	@Prop({ required: true, type: String })
	public label!: string;

	@Prop({ required: false, type: Boolean })
	public inputValid?: boolean | null;

	@Prop({ required: false, type: String })
	public invalidFeedbackMessage?: string | null;
}
